
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { Account } from "../Account.model";
import { PointOfService } from "../PointOfService.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class Account_POS extends GenericEntityBase<string> {
  private _id?: string = undefined;
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_Account}-${this.fK_POS}`;
    }
    return this._id;
  }

  override _isRelationEntity = true; 

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Account!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_POS!: number;

  isTruckerResponsible!: boolean;

  @NestedProperty({ TargetType: Account })
  account?: Account;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  GetType(): IEntityMetaData {
    return Account_POS.getMetaData();
  }
}
